import script from "./ViewReactive.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewReactive.vue?vue&type=script&setup=true&lang=js"

import "./ViewReactive.vue?vue&type=style&index=0&id=4677bdce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4677bdce"]])

export default __exports__